const state = {
  all: [
    {
      hash: 'create-badge',
      show: false,
      data: {
        category_id: null,
        badge_parent_id: null,
        badge_parent_status: null
      }
    },
    {
      hash: 'edit-badge',
      show: false,
      data: {
        category_id: null,
        badge_parent_id: null
      }
    },
    {
      hash: 'form-badge',
      show: false,
      data: {
        category_id: null,
        badge_parent_id: null
      }
    }
  ]
}

// getters
const getters = {
  modal: (state, hash) => state.all,
  isOneOpen: (state) => {
    return state.all.some(modal => modal.show)
  }
}

// actions
const actions = {

  toggle: (store, modal) => {
    store.commit('TOGGLE_MODAL', modal)
  }
}

// mutations
const mutations = {
  TOGGLE_MODAL: (state, _modal) => {
    state.all.forEach(function (modal) {
      if (modal.hash === _modal.hash) {
        // Add Data
        for (var k in _modal.data) {
          modal.data[k] = _modal.data[k]
        }
        // Toggle
        modal.show = !modal.show
      }
    })
  },
  RESET_MODAL: (state, modal) => {
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/modals.js